import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validators } from '@angular/forms';
import { CompleterData, CompleterService } from "ng2-completer";
import { CONFIG } from '../../../config';
import { CatalogueService } from '../../../core/service/core/cataloque.service';
import { ValidatorService } from '../../../core/service/app/validator.service';
import { promise } from 'selenium-webdriver';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent extends FormBaseComponent<any> implements OnInit, OnChanges {


  @Input()
  postalCode: string;

  protected dataService: any;

  listColony = []

  codigoPostal = '0'

  constructor(private completerService: CompleterService, private catalogueService: CatalogueService, private validatorService: ValidatorService) {
    super();
    this.dataService = completerService.remote(CONFIG.url + 'catalogue/postalcode/', null, null)
  }


  ngOnInit() {
    this.init(true)
    if (this.postalCode) {
      this.loadData(this.postalCode);
      this.form.patchValue({ 'postalCode': this.postalCode })
    }

    this.form.valueChanges.subscribe(state => {
      if (this.codigoPostal != state.postalCode) {
        this.codigoPostal = state.postalCode;
        this.loadData(this.codigoPostal);
      }
    })
  }


  template() {
    //this.form.addControl('postalCode', new FormControl('', [Validators.required, Validators.pattern('[0-9]{0,6}')], [this.postalCodeAsync.bind(this)]));
    this.form.addControl('postalCode', new FormControl(''));
    this.form.addControl('estate', new FormControl(''));
    this.form.addControl('municipality', new FormControl(''));
    this.form.addControl('colony', new FormControl(''));
    this.form.addControl('street', new FormControl(''));
    this.form.addControl('phone1', new FormControl('', [this.validatorService.telefono]));
    this.form.addControl('phone2', new FormControl('', [this.validatorService.telefono]));
    this.form.addControl('numInt', new FormControl(''));
    this.form.addControl('numExt', new FormControl(''));
    this.form.addControl('population', new FormControl());
  }

  ngOnChanges(changes) {
    if (changes) {
      if (changes.postalCode) {
        this.loadData(changes.postalCode.currentValue);
        if (this.form) {
          this.form.patchValue({ 'postalCode': changes.postalCode.currentValue })
        }
      }
    }
  }


  loadInfo() {
    if (this.state.postalCode.length > 0) {
      this.loadData(this.state.postalCode);
    }
  }

  loadData(value: string) {
    if (value != '00000' && value != null && value.trim().length > 0 && value != '0') {
      this.listColony = [];
      this.catalogueService.getByPostalCode(value)
        .then(result => {
          if (result != undefined) {
            this.form.patchValue({ 'estate': result.state, 'municipality': result.municipality })
            result.colonies.map(item => {
              this.listColony.push({ text: item.text, value: item.value })
            })
          }
        })
    }
  }

  postalCodeAsync(control: FormControl)
  {
    return this.validatorService.postalCode(control.value).then( data => {
      return data? null : {error: 'Codigo Postal Invalido.'}
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/form/form/address-form/address-form.component.ts